// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3OZB5","comment":"styles_comment__2TQVv"};